import { gql } from '@apollo/client'

export const ComplementProcedureFragment = gql`
  fragment ComplementProcedure on d4_complementprocedure {
    id
    article700
    cequiestdemande
    defendeur
    dateassignation
    datedemiseendelibere
    datepremierecomparution
    datereceptioncertificatdenonappel
    datereceptionassignation
    delibere
    origine
    referenceavocat
    referencehuissier
    referencetribunal
    statutprocedure
    statutprocedure
    tribunal
    procedure_id
    avocat_id
    demande {
      copropriete_id
    }
    fichierassignation {
      id
      nomfichier
      nomstockage
      datecreation
    }
    fichierordonnance {
      id
      nomfichier
      nomstockage
      datecreation
    }
    fichiercertificatdenonappel {
      id
      nomfichier
      nomstockage
      datecreation
    }
  }
`
